import React from 'react';
import {
    ControlsContainer,
    HeaderComponent,
} from 'components/customer/RoomPlanner/components/Menu/Header';
import Room from 'components/customer/Room/Room';
import styled from 'styled-components';
import {mobileLandscape} from 'shared/Breakpoints';

export const Hardware = () => {
    return (
        <div>
            <HeaderComponent>
                <ControlsContainer>
                    <Header>Current hardware options</Header>
                </ControlsContainer>
            </HeaderComponent>

            <br />
            <Room tabIndex={1} isMiniEditor={true} showTabNavs={[]} />
        </div>
    );
};

const Header = styled.div`
    color: ${({theme}) => theme.colors.primary.main};
    font-size: 0.9rem;
    font-weight: 600;
    margin-top: 10px;
    margin-left: 4px;

    ${mobileLandscape`
        font-size: 1.025em;
        font-weight: 500;
    `}
`;
